import { countData } from "./countDataType";

const setCountData = (data) => ({ type: countData.SET_COUNT_DATA, payload: data });

export { setCountData };